export {
  isIdentifierName,
  isIdentifierChar,
  isIdentifierStart,
} from "./identifier.ts";
export {
  isReservedWord,
  isStrictBindOnlyReservedWord,
  isStrictBindReservedWord,
  isStrictReservedWord,
  isKeyword,
} from "./keyword.ts";
